import { RidangoReduxAction } from '@ridango/core';

import { AlertState } from '../notification.models';
import { NotificationAction } from './notification.actions';

export const NOTIFICATION_STATE_KEY = 'notification';

export interface NotificationState {
    alerts: AlertState[];
}

export const NOTIFICATION_INITIAL_STATE: NotificationState = {
    alerts: []
};

export function notificationReducer(state = NOTIFICATION_INITIAL_STATE, action: RidangoReduxAction): NotificationState {
    switch (action.type) {
        case NotificationAction.ADD_ALERT: {
            // Append the new alert to the queue (changed from replacing)
            return {
                ...state,
                alerts: [...state.alerts, action.payload]
            };
        }

        case NotificationAction.REMOVE_ALERT: {
            const newAlerts = state.alerts.filter((alert) => alert.id !== action.payload.id);
            return {
                ...state,
                alerts: newAlerts
            };
        }

        case NotificationAction.REMOVE_ALL_ALERTS: {
            return {
                ...state,
                alerts: []
            };
        }

        case NotificationAction.CLEAR_ROUTE_CHANGE_FLAGS: {
            // Clear the showAfterRouteChange flag so these alerts now display normally.
            // This happens on NavigationEnd - the alerts survived the route change and should now show.
            const clearedAlerts = state.alerts.map((alert) => {
                return {
                    ...alert,
                    showAfterRouteChange: false
                };
            });
            return {
                ...state,
                alerts: clearedAlerts
            };
        }

        case NotificationAction.FILTER_NEXT_PAGE_ALERTS: {
            // Remove all alerts that should NOT persist to the next route.
            // Alerts with showAfterRouteChange=true will remain for the next page.
            const nextPageAlerts = state.alerts.filter((alert) => {
                return alert.showAfterRouteChange === true;
            });
            return {
                ...state,
                alerts: nextPageAlerts
            };
        }
    }

    return state;
}

export interface NotificationPartialStoreState {
    [NOTIFICATION_STATE_KEY]: NotificationState;
}
